import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { FaTimes } from "react-icons/fa";

const LogoutAlertModal = ({ isModalOpened, handleSelectedFunc }) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isModalOpened} backdrop={false} centered toggle={() => handleSelectedFunc({ selectedFunc: "LOGOUT_ALERT_TOGGLE" })} className="hc-session-alert-modal" contentClassName="hc-session-alert-content">
            <div className="hc-session-alert-card">
                <div className="hc-session-alert-body">
                    <div className="hc-session-alert-title">
                        <span>{t("강제_로그아웃_알림", { ns: "user" })}</span>
                    </div>
                    <div className="hc-session-alert-message">
                        <div className="hc-session-alert-text">
                            <span>{t("로그아웃_알림_문구_1", { ns: "user" })}</span>
                            <span>{t("로그아웃_알림_문구_2", { ns: "user" })}</span>
                        </div>
                    </div>
                    <button type="button" className="hc-session-alert-btn hc-session-alert-btn-primary" onClick={() => handleSelectedFunc({ selectedFunc: "LOGOUT_ALERT_TOGGLE" })}>{t("확인", { ns: "common" })}</button>
                </div>
            </div>
        </Modal>
    );
}

export default LogoutAlertModal;